import { render, staticRenderFns } from "./vehicleForm.vue?vue&type=template&id=33168046&scoped=true&"
import script from "./vehicleForm.vue?vue&type=script&lang=js&"
export * from "./vehicleForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33168046",
  null
  
)

export default component.exports